import type { ReactNode } from 'react';
import { DiscoveryRightRail } from '@/platform/calendar/CalendarSidebarWidget';
import { PaydirtSidebar } from './PaydirtSidebar';

type Props = {
  children: ReactNode;
  right?: ReactNode;
  hideSidebar?: boolean;
};

/** Three-column discovery shell (nav is in PaydirtChrome). Prefer {@link DiscoveryPageLayout} for standard content pages. */
export function DiscoveryLayout({ children, right, hideSidebar }: Props) {
  return (
    <div className="discovery-layout">
      <div className="discovery-layout__grid">
        {!hideSidebar && (
          <div className="discovery-layout__left">
            <PaydirtSidebar />
          </div>
        )}
        <main className="discovery-layout__main">{children}</main>
        {(right || !hideSidebar) && <DiscoveryRightRail right={right} />}
      </div>
    </div>
  );
}
